import _ from "lodash"
import { Product, ProductData } from "../../../../types"
import { Feature } from "@turf/helpers"

export const prepareProductData = (
  product: Product,
  findOne: (id: string) => Feature
): ProductData => {
  // Prepare Event
  const { category_ids, occupant_id } = product.properties
  const occupant = findOne(occupant_id)
  const localCategories = _(category_ids).map(findOne).compact().value()

  const [parentCategories, subCategories] = _.partition(
    localCategories,
    (cat) => cat?.properties.parent_id === null
  )

  return {
    ...product,
    properties: {
      ...product.properties,
      occupant,
      local_categories: localCategories,
      local_parent_categories: parentCategories,
      local_sub_categories: subCategories,
    },
  }
}
